import { createSlice } from '@reduxjs/toolkit';
import forOwn from 'lodash/forOwn';

import { LESSON_TYPES } from '../data/lessonTypes';
import getEndTimeOfInterviewbitTest from '../utils/getEndTimeOfInterviewbitTest';
import getStartTimeOfNextInterviewbitTest from '../utils/getStartTimeOfNextInterviewbitTest';

const initialState = {
  groupContestModalState: false,
  selectedSbatGroup: null,
  selectedInterviewbitTest: null,
  groupContestCourseType: null,
};

export const editSbatGroup = createSlice({
  name: 'editSbatGroup',
  initialState,
  reducers: {
    setGroupContestModalState: (state, action) => {
      state.groupContestModalState = action.payload;
    },
    setEditSbatGroupSelectedSbatGroup: (state, action) => {
      state.selectedSbatGroup = action.payload;
    },
    updateSbatGroupContestLessonDuration: (state, action) => {
      forOwn(state.selectedSbatGroup?.academy_topic?.lessons, (lesson) => {
        if (lesson.lesson_type !== LESSON_TYPES.contest) return;

        lesson.duration = action.payload;

        forOwn(lesson.meta.interviewbit_tests, (interviewbitTest) => {
          const updatedEndTime = getEndTimeOfInterviewbitTest(
            interviewbitTest,
            lesson.duration
          );

          interviewbitTest.end_time = new Date(updatedEndTime).toISOString();
        });
      });
    },
    updateSbatGroupInterviewbitTest: (state, action) => {
      const updatedInterviewbitTest = action.payload;
      const groupContestCourseType = updatedInterviewbitTest.course_type;
      forOwn(state.selectedSbatGroup?.academy_topic?.lessons, (lesson) => {
        if (lesson.lesson_type !== LESSON_TYPES.contest) return;
        let selectedIndex;
        forOwn(lesson.meta.interviewbit_tests, (interviewbitTest, index) => {
          if (interviewbitTest.test_id === updatedInterviewbitTest.test_id) {
            selectedIndex = index;
            const updatedStartTime = new Date(
              updatedInterviewbitTest.start_time
            ).toISOString();
            const updatedEndTime = getEndTimeOfInterviewbitTest(
              updatedInterviewbitTest,
              lesson.duration
            );
            interviewbitTest.start_time = updatedStartTime;
            interviewbitTest.end_time = updatedEndTime;
          }
          if (index > selectedIndex) {
            const previousInterviewbitTest =
              lesson.meta.interviewbit_tests[index - 1];

            const updatedStartTime = getStartTimeOfNextInterviewbitTest({
              previousInterviewbitTest,
              currentInterviewbitTest: interviewbitTest,
              courseType: groupContestCourseType,
              seq: index,
            });

            interviewbitTest.start_time = new Date(
              updatedStartTime
            ).toISOString();

            const updatedEndTime = getEndTimeOfInterviewbitTest(
              interviewbitTest,
              lesson.duration
            );
            interviewbitTest.end_time = new Date(updatedEndTime).toISOString();
          }
        });
      });
    },
    setEditSbatGroupSelectedInterviewbitTest: (state, action) => {
      state.selectedInterviewbitTest = action.payload;
    },
    setGroupContestCourseType: (state, action) => {
      state.groupContestCourseType = action.payload;
    },
    resetEditSbatGroup: (state, action) => {
      state.groupContestModalState = false;
      state.selectedSbatGroup = null;
      state.selectedInterviewbitTest = null;
    },
  },
});

export const {
  resetEditSbatGroup,
  setEditSbatGroupSelectedInterviewbitTest,
  setEditSbatGroupSelectedSbatGroup,
  setGroupContestCourseType,
  setGroupContestModalState,
  updateSbatGroupContestLessonDuration,
  updateSbatGroupInterviewbitTest,
} = editSbatGroup.actions;
export default editSbatGroup.reducer;
